module.exports = __webpack_public_path__ + "frequency.svg?b49a01fd7a6f49231c5235e540d19a93";